// Generated by scripts/generate_component_entries.mjs from packages/client/component-entries.json.
// Do not edit by hand.
import type {Alpine as AlpineType} from 'alpinejs';

import {registerField as registerComponent} from './index';

const registered = new WeakSet<AlpineType>();

const registerField = (AlpineInstance: AlpineType): void => {
    if (registered.has(AlpineInstance)) return;
    registered.add(AlpineInstance);

    registerComponent(AlpineInstance);
};

export {registerField};
export default registerField;
export * from './index';
